<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
        <mat-form-field appearance="outline" style="width: 83%">
          <textarea [(ngModel)]="msg" matInput #userinput spellcheck="false" rows="2" readonly></textarea>
        </mat-form-field>
        <button mat-flat-button color="accent" *ngIf="copied" style="    margin-left: 10px;
        height: 65px;
        position: relative;
        top: -11px;
        width: 100px">  <mat-icon style="margin-right: 5px;" class="material-icons-round" [inline]="true"
        >done</mat-icon
      >Copied
      </button>
        <button
        *ngIf="!copied"
        mat-button 
        style="border: 1px solid rgb(180, 135, 0);
        margin-left: 10px;
        height: 65px;
        position: relative;
        top: -11px;
        width: 100px;
    "
        (click)="copyInputMessage(userinput)"
      >
        Copy
      </button>
  
      <!-- <textarea type="text" [(ngModel)]="msg" #userinput></textarea> -->
      <!-- <a href="javascript:void(0)" (click)="copyInputMessage(userinput)">
        <span id="link-copy">Copy Link</span>
      </a> -->
  </mat-dialog-content>
  